import PropTypes from 'prop-types';
import Search from '@lsq/nextgen/v2/text-field/search-bar';

export default function CustomInputV2({
  placeholder = '',
  value = '',
  onChange,
  size = 'sm',
  ...props
}) {
  // Search calls onChange(string); callers expect onChange({target:{value}})
  const handleChange = (val) => {
    onChange?.({ target: { value: val } });
  };

  return (
    <Search
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      size={size}
      {...props}
    />
  );
}

CustomInputV2.propTypes = {
  placeholder: PropTypes.string,
  RightIcon: PropTypes.object,
  leftIconOnClick: PropTypes.func,
  rightIconOnClick: PropTypes.func,
  value: PropTypes.string,
  onChange: PropTypes.func
};
